import React, { useState } from 'react'
import { FullTrainingSvg, MarketingSvg, OperationalSvg, TerritorySvg } from '../svg'
import { TbArrowNarrowRight } from "react-icons/tb";
import SplitText from "../../../common/SplitText";
import ContactModal from "../../../modal/ContactModal";

export default function GetFranchise() {
    const [position, setPosition] = React.useState(window.innerWidth <= 645);
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);
    
    React.useEffect(() => {
        window.onresize = function () {
            setPosition(window.innerWidth <= 645);
        };
    }, []);

    return (
        <div className='mt-[100px] relative'>
            <div className='bg-[#F0FBF8] w-full rounded-t-[30px] sm:rounded-t-[60px] pt-[50px] sm:pt-[80px] pb-[35px] sm:pb-[60px]'>
                <div className='flex justify-center'>
                    <SplitText
                        text="What You Get as a Franchisee"
                        tag="h2"
                        className='text-[#0F0200] font-bold text-[28px] sm:text-[40px] lg:text-[48px] xl:text-[56px] text-center max-w-[840px] mx-auto'
                        delay={30}
                        duration={0.6}
                        ease="power3.out"
                        splitType="words, chars"
                        from={{ opacity: 0, y: 30 }}
                        to={{ opacity: 1, y: 0 }}
                        threshold={0.1}
                        rootMargin="-40px"
                        textAlign="center"
                    />
                </div>
                <div className='w-11/12 max-w-[1360px] mx-auto grid lg:grid-cols-2 gap-[20px] sm:gap-[28px] mt-[40px] sm:mt-[50px]'>
                    <div className='p-[24px] sm:p-[32px] bg-white rounded-[24px] border border-teal-100/60 shadow-sm hover:shadow-md transition-all flex gap-[20px] sm:gap-[28px] items-start'>
                        <div className='flex shrink-0 rounded-[20px] p-2 bg-[#E0F6F1]'>
                            <FullTrainingSvg size={position ? "44" : "64"}/>
                        </div>
                        <div>
                            <h3 className='text-[#181F38] text-[20px] sm:text-[22px] font-bold'>Full Training Program</h3>
                            <p className='text-[#475569] text-[15px] sm:text-[16px] font-normal mt-[8px] leading-relaxed'>Get hands-on training in kulfi preparation, cart operations, inventory management, and customer service.</p>
                        </div>
                    </div>

                    <div className='p-[24px] sm:p-[32px] bg-white rounded-[24px] border border-teal-100/60 shadow-sm hover:shadow-md transition-all flex gap-[20px] sm:gap-[28px] items-start'>
                        <div className='flex shrink-0 rounded-[20px] p-2 bg-[#E0F6F1]'>
                            <TerritorySvg size={position ? "44" : "64"}/>
                        </div>
                        <div>
                            <h3 className='text-[#181F38] text-[20px] sm:text-[22px] font-bold'>Exclusive Territory</h3>
                            <p className='text-[#475569] text-[15px] sm:text-[16px] font-normal mt-[8px] leading-relaxed'>Enjoy a protected territory to ensure minimal competition and maximize foot traffic in your area.</p>
                        </div>
                    </div>

                    <div className='p-[24px] sm:p-[32px] bg-white rounded-[24px] border border-teal-100/60 shadow-sm hover:shadow-md transition-all flex gap-[20px] sm:gap-[28px] items-start'>
                        <div className='flex shrink-0 rounded-[20px] p-2 bg-[#E0F6F1]'>
                            <OperationalSvg size={position ? "44" : "64"}/>
                        </div>
                        <div>
                            <h3 className='text-[#181F38] text-[20px] sm:text-[22px] font-bold'>Ongoing Operational Support</h3>
                            <p className='text-[#475569] text-[15px] sm:text-[16px] font-normal mt-[8px] leading-relaxed'>From product deliveries to troubleshooting, we provide WhatsApp support, dedicated call assistance, and quarterly networking meetups.</p>
                        </div>
                    </div>

                    <div className='p-[24px] sm:p-[32px] bg-white rounded-[24px] border border-teal-100/60 shadow-sm hover:shadow-md transition-all flex gap-[20px] sm:gap-[28px] items-start'>
                        <div className='flex shrink-0 rounded-[20px] p-2 bg-[#E0F6F1]'>
                            <MarketingSvg size={position ? "44" : "64"}/>
                        </div>
                        <div>
                            <h3 className='text-[#181F38] text-[20px] sm:text-[22px] font-bold'>Brand Marketing Materials</h3>
                            <p className='text-[#475569] text-[15px] sm:text-[16px] font-normal mt-[8px] leading-relaxed'>Ready-made templates for social media, local advertising, and promotional materials to help you build your local customer base.</p>
                        </div>
                    </div>
                </div>
            </div>
            
            <button 
                type='button'
                onClick={() => setIsContactModalOpen(true)}
                className='group bg-[#E4F8F2] hover:bg-[#d5f3ec] w-full rounded-b-[30px] sm:rounded-b-[60px] py-[22px] flex justify-center items-center gap-[15px] sm:gap-[23px] cursor-pointer text-[20px] sm:text-[24px] font-bold text-[#181F38] transition-colors duration-200'
            >
                <span>Get Started</span>
                <TbArrowNarrowRight className='text-[#00B884] text-[28px] group-hover:translate-x-2 transition-transform duration-200' />
            </button>

            <ContactModal 
                isOpen={isContactModalOpen} 
                onClose={() => setIsContactModalOpen(false)} 
            />
        </div>
    )
}
